import React, { FunctionComponent, MutableRefObject, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { View, GestureResponderHandlers } from 'react-native'
import { BackgroundColorTypes } from '../../Theme/Fonts/FontTypes'
import { TestID } from '../../utils/PropTypesDefinitions'
import {
    BorderProps,
    DisplayProp,
    getPaddingPropsBySpacing,
    MarginProps,
    PaddingProps,
    PositionProps,
    SpacingProps,
} from '../../utils/styling/StylingHelper'

export type NonFlexingContainerProps = GestureResponderHandlers &
    SpacingProps &
    MarginProps &
    PaddingProps &
    PositionProps &
    DisplayProp &
    BorderProps &
    TestID & {
        innerRef?: MutableRefObject<(ReactElement & (View | HTMLDivElement)) | null>
        horizontal?: boolean
        backgroundColor?: BackgroundColorTypes
        width?: number | string
        maxWidth?: number | string
        minWidth?: number | string
        height?: number | string
        minHeight?: number | string
        maxHeight?: number
        collapsable?: boolean
        pointerEvents?: 'none' | 'auto' | 'box-none' | 'box-only'
        opacity?: number
        elevation?: number
        alignRight?: boolean
        centerVertical?: boolean
        centerHorizontal?: boolean
        flexWrap?: 'wrap' | 'noWrap'
        overflow?: 'visible' | 'hidden' | 'scroll'
    }

const NonFlexingContainer: FunctionComponent<NonFlexingContainerProps> = ({
    children,
    innerRef,
    spaceX,
    spaceY,
    spaceLeft,
    spaceRight,
    spaceBottom,
    spaceTop,
    ...rest
}): ReactElement => {
    return (
        <Grid
            ref={innerRef}
            {...getPaddingPropsBySpacing({
                spaceX,
                spaceY,
                spaceLeft,
                spaceRight,
                spaceBottom,
                spaceTop,
            })}
            {...rest}
            noExpand
        >
            {children}
        </Grid>
    )
}

export default NonFlexingContainer
